import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://c5dfe1b8eb8f51df84d3aae15c598bed@o4511027149144064.ingest.us.sentry.io/4511028540604416",
  sendDefaultPii: true,
});

// Test events — remove after verifying in Sentry dashboard
Sentry.captureMessage("Frontend test event - Sentry is working!", "info");
Sentry.captureException(new Error("Frontend test error - Sentry exception tracking verified"));

createRoot(document.getElementById("root")!).render(<App />);
